import { IconProps } from '.';

const BankIconBackground: React.FC<React.PropsWithChildren<IconProps>> = ({ size = 36 }) => {
  return <rect width={size} height={size} rx="4" fill="#F5F5F5" />;
};

export default BankIconBackground;
